<div class="otp-row">
  <ng-container *ngFor="let _ of digits; let i = index">
    <div class="otp-field" [class.focused]="focusedIndex === i">
      <input
        #otpBox
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        [autocomplete]="i === 0 ? 'one-time-code' : 'off'"
        (focus)="onFocus(i)"
        (blur)="onBlur()"
        (input)="onInput($event, i)"
        (keydown)="onKeydown($event, i)"
        (paste)="onPaste($event)"
      />
      <div class="otp-underline"></div>
    </div>
    <span *ngIf="i === 2" class="otp-separator">–</span>
  </ng-container>
</div>
<button type="button" color="primary" mat-button (click)="pasteFromClipboard()">{{ 'security.two-factor-auth.paste-code' | translate }}</button>
